import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

const links = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "why", label: "Why Us" },
  { id: "products", label: "Products" },
  { id: "leadership", label: "Leadership" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050B14]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="flex items-center gap-3 group"
        >
          <span className="inline-flex h-11 w-11 rounded-full bg-white items-center justify-center overflow-hidden shadow-[0_0_24px_rgba(255,200,87,0.35)] group-hover:scale-105 transition-transform">
            <img
              src={COMPANY.logo}
              alt="Jashvi Energy Solutions"
              className="h-10 w-10 object-contain"
            />
          </span>
          <span className="font-serif text-lg md:text-xl tracking-wide text-white leading-tight">
            Jashvi Energy
            <span className="block text-[10px] uppercase tracking-[0.3em] text-[#FFC857] font-sans font-light">
              Solutions
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              data-testid={`nav-link-${l.id}`}
              key={l.id}
              onClick={() => go(l.id)}
              className="text-sm uppercase tracking-[0.18em] text-[#A0ABC0] hover:text-[#FFC857] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            data-testid="nav-cta-quote"
            onClick={() => go("enquiry")}
            className="btn-gold text-sm"
          >
            <Phone className="h-4 w-4" /> Get Free Quote
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-white/5 bg-[#050B14]/95 backdrop-blur-xl"
        >
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <button
                data-testid={`nav-mobile-link-${l.id}`}
                key={l.id}
                onClick={() => go(l.id)}
                className="text-left text-sm uppercase tracking-widest text-[#A0ABC0] hover:text-[#FFC857] py-2"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => go("enquiry")}
              className="btn-gold w-full justify-center mt-2"
            >
              <Phone className="h-4 w-4" /> Get Free Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
